<template>
  <div class="mainContentAdmin" id="weblogCategories">
    <b-overlay :show="status" no-wrap fixed z-index="9999">
      <template v-slot:overlay>
        <div class="d-flex align-items-center">
          <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
          <b-spinner type="grow" variant="dark" class="mx-1"></b-spinner>
          <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
        </div>
      </template>
    </b-overlay>
    <div class="filters">
      <b-button variant="primary" @click="showModal = true">افزودن </b-button>
    </div>
    <div v-if="items" class="mainTable">
       <s-table
                    v-model="items"
                    @showEditModal="showEditModal"
                    @deleteItem="deleteItem"
                    :settings="settings"
                    :headers="headers"
                  />
    </div>
    <div v-if="items != null && totalPages > 1">
      <div id="pagination">
        <pagination
          @pageChanged="pageChanged"
          :totalPages="totalPages"
          :currentPage="currentPage"
        />
      </div>
    </div>
    <b-modal
      id="categoryModal"
      hide-footer
      ref="categoryModal"
      no-close-on-backdrop
      v-model="showModal"
      @close="resetModal()"
      :title="mode == 'create' ? 'افزودن ' + title : ' ویرایش ' + title"
    >
      <s-inputs
        :disabled="disabled"
        @submit="submit"
        :mode="mode"
        :bigData="bigData"
        :headers="headers"
        :folderRoute="'galleries'"
        :settings="settings"
      />
    </b-modal>
  </div>
</template>
<script>
import pagination from "@/components/front/shared/pagination.vue";
import SInputs from "@/components/admin/shared/sInputs.vue";
import STable from "@/components/admin/shared/sTable.vue";
import adminMixin from "@/libraries/adminController.js"
import { BModal, BButton,BOverlay,BSpinner } from "bootstrap-vue";
export default {
mixins:[adminMixin],
  components: { SInputs, BModal, BButton, STable,BOverlay,BSpinner,pagination },
  data() {
    return {
      headers: [
        {
          style: "col-6",
          show_in_table: true,
          placeholder: "نام  تصویر را وارد کنید",
          type: "string",
          multiData: true,
          name: "نام تصویر ",
          key: "title"
        },
        {
          style: "col-12",
          show_in_table: true,
          placeholder: "تصویر را در ارتفاع 450 و عرض 800 پیکسل  وارد کنید",
          type: "image",
          multiData: false,
          name: "تصویر را وارد کنید",
          key: "image"
        },
        {
          style: "col-6",
          show_in_table: true,
          placeholder: "دسته بندی را انتخاب کنید",
          type: "select",
          multiData: false,
          name: " دسته بندی",
          multiple: false,
          selectIN: "GalleryCategory",
          key: "categoryId"
        },
        {
          style: "col-6",
          show_in_table: false,
          //placeholder: "تصوير آزمايشگاه كاليبراسيون  را انتخاب کنید",
          type: "boolean",
          multiData: false,
          name: "تصوير آزمايشگاه كاليبراسيون ",
         // multiple: false,
         // selectIN: "GalleryCategory",
          key: "isCalibrationLab"
        },
        {
          style: "col-6",
          show_in_table: true,
          placeholder: "",
          type: "setting",
          name: "تنظیمات",
          multiData: false,
          key: "",
          edit: true,
          delete: true
        }
      ],
      pageSize: 10,
      bigData: {
        persian: {},
        english: {},
        both: {}
      },
      title: "گالری",
      editedId: null,
      apiRoute: "Gallery",
    };
  },

  mounted() {
    if (this.$route.query.page) {
      this.currentPage = this.$route.query.page;
    } else {
      this.currentPage = 1;
    }
    this.loadSettings([{  route: "GalleryCategory", field: "name" }]);
    this.loadItems(this.currentPage);
  },
 // created() {
      // this.$store.dispatch("getProductFromServer", this.$route.params.id);
      //this.checkRequest('getGalleryCategoryFromServer',JSON.stringify(null));
      //this.checkRequest('getUnitProductsFromServer',JSON.stringify(null));
      //this.checkRequest('getFieldActivitysFromServe',JSON.stringify(null));

  //},
  watch:{
      item(newVal){
          this.bigData = newVal
      }
  },
  methods: {
    showModalFunction() {
      this.showModal = true;
      setTimeout(() => {
        document
          .getElementById("blogModal___BV_modal_content_")
          .removeAttribute("tabindex");
      });
    }
  }
};
</script>
<style></style>


<!--  <template>
   <div class="mainContentAdmin" id="weblogCategories">
    <b-overlay :show="status" no-wrap fixed z-index="9999">
      <template v-slot:overlay>
        <div class="d-flex align-items-center">
          <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
          <b-spinner type="grow" variant="dark" class="mx-1"></b-spinner>
          <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
        </div>
      </template>
    </b-overlay>
    <div class="filters">
      <b-button variant="primary" @click="showModal = true">افزودن </b-button>
    </div>
    <div v-if="items" class="mainTable">
       <s-table
                    v-model="items"
                    @showEditModal="showEditModal"
                    @deleteItem="deleteItem"
                    :headers="headers"
                  />
    </div>
    <b-modal
      id="categoryModal"
      hide-footer
      ref="categoryModal"
      no-close-on-backdrop
      v-model="showModal"
      @close="resetModal()"
      :title="mode == 'create' ? 'افزودن ' + title : ' ویرایش ' + title"
    >
      <s-inputs
        :disabled="disabled"
        @submit="submit"
        :mode="mode"
        :bigData="bigData"
        :headers="headers"
      />
    </b-modal>
  </div> 

</template>
 <script>
import SInputs from "@/components/admin/shared/sInputs.vue";
import STable from "@/components/admin/shared/sTable.vue";
import adminMixin from "@/libraries/adminController.js"
import { BModal, BButton,BOverlay,BSpinner } from "bootstrap-vue";
export default {
mixins:[adminMixin],
  components: { SInputs, BModal, BButton, STable,BOverlay,BSpinner },
  data() {
    return {
      headers: [
        {
          style: "col-12",
          show_in_table: true,
          placeholder: "نام  تصویر را وارد کنید",
          type: "string",
          multiData: true,
          name: "نام تصویر ",
          key: "title"
        },
        {
          style: "col-12",
          show_in_table: true,
          placeholder: "تصویر را در ارتفاع 450 و عرض 800 پیکسل  وارد کنید",
          type: "image",
          multiData: false,
          name: "تصویر را وارد کنید",
          key: "image"
        },
        {
          style: "col-12",
          show_in_table: true,
          placeholder: "",
          type: "setting",
          name: "تنظیمات",
          multiData: false,
          key: "",
          edit: true,
          delete: true
        }
      ],
      bigData: {
        persian: {},
        english: {},
        both: {}
      },
      title: "گالری",
      editedId: null,
      apiRoute: "Gallery"
    };
  },
 // mounted() {
    // if (this.$route.query.page) {
    //   this.currentPage = this.$route.query.page;
    // } else {
    //   this.currentPage = 1;
    // }
     // this.loadItems();
     // this.loadSettings([ {route: "GalleryCategory", field: "name"} ]);
     // this.loadItems(this.currentPage);
  //},
  watch:{
      item(newVal){
          this.bigData = newVal
      }
  }
  // methods: {
  //   showModalFunction() {
  //     this.showModal = true;
  //     setTimeout(() => {
  //       document
  //         .getElementById("blogModal___BV_modal_content_")
  //         .removeAttribute("tabindex");
  //     });
  //   }
  // }
};
</script>
<style></style>   -->
